$(function () {
    // 工具函数：检查是否为移动端
    const isMobile = () => window.innerWidth < 768;

    // 数字动画函数
    const animateNumber = (element, start, end, duration = 2000) => {
        const startTime = performance.now();
        const range = end - start;

        const updateNumber = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            // 使用缓动函数让动画更自然
            const easeOutCubic = 1 - Math.pow(1 - progress, 3);
            const currentNumber = Math.floor(start + (range * easeOutCubic));

            // 添加千位分隔符
            const formattedNumber = currentNumber.toLocaleString();
            element.textContent = `${formattedNumber}ft`;

            if (progress < 1) {
                requestAnimationFrame(updateNumber);
            }
        };

        requestAnimationFrame(updateNumber);
    };

    // 动画函数集合
    const myAnimate = {
        // 通用备份动画函数（用于 backup-product-cover 等）
        backupFn(r, obj, y) {
            if (r >= 0.5 && !$(obj).hasClass('text-float')) obj.classList.add('text-float');
            if (r < 0.5 && y > 0) obj.classList.remove('text-float');

            if (r >= 0.7 && !$(obj).hasClass('animate')) {
                obj.classList.add('animate');
                setTimeout(() => {
                    $('.backup-product-cover').css({ opacity: 0, transition: 'opacity 0.5s ease' });
                }, 550);
            }
            if (r < 0.7 && y > 0) {
                obj.classList.remove('animate');
                $('.backup-product-cover').css({ opacity: 1, transition: 'opacity 0.5s ease' });
            }

            if (r < 0.4 && y < 0) obj.classList.add('overhidden');
            if (r >= 0.4) obj.classList.remove('overhidden');
        },
        // 子导航固定效果
        subnavFixed(r, obj) {
            if (r > 0) {
                $('#subnav-box').removeClass('header-fixed');
                $('.subnav-container').removeClass('header-bg-black');
            } else {
                $('#subnav-box').addClass('header-fixed');
                $('.subnav-container').addClass('header-bg-black');
            }
        },
        // 通用类添加动画
        addClass(r, obj, y) {
            if (r >= 0.3 && !$(obj).hasClass('text-float')) {
                obj.classList.add('text-float');

                // 检查是否是数字动画元素
                const numberElements = obj.querySelectorAll('[data-target]');
                numberElements.forEach(element => {
                    if (!element.hasAttribute('data-animated')) {
                        const target = parseInt(element.getAttribute('data-target'));
                        animateNumber(element, 0, target, 2000);
                        element.setAttribute('data-animated', 'true');
                    }
                });
            }
            if (r < 0.3 && y > 0) {
                obj.classList.remove('text-float');

                // 重置数字动画
                const numberElements = obj.querySelectorAll('[data-target]');
                numberElements.forEach(element => {
                    element.textContent = '0ft';
                    element.removeAttribute('data-animated');
                });
            }

            if (r >= 0.7 && !$(obj).hasClass('animate')) obj.classList.add('animate');
            if (r < 0.7 && y > 0) obj.classList.remove('animate');

            if (r < 0.4 && y < 0) obj.classList.add('overhidden');
            if (r >= 0.4) obj.classList.remove('overhidden');
        },
        // 月度类添加动画（阈值稍高）
        addClassMonths(r, obj, y) {
            if (r >= 0.5 && !$(obj).hasClass('text-float')) obj.classList.add('text-float');
            if (r < 0.5 && y > 0) obj.classList.remove('text-float');

            if (r >= 0.7 && !$(obj).hasClass('animate')) obj.classList.add('animate');
            if (r < 0.7 && y > 0) obj.classList.remove('animate');

            if (r < 0.4 && y < 0) obj.classList.add('overhidden');
            if (r >= 0.4) obj.classList.remove('overhidden');
        },
        // 横幅图片固定效果
        bannerImgFixed(r, obj, y) {
            const $el = $('.banner-container .banner-p1 .banner-img');
            const $titleEl = $('.banner-container .banner-p1 .banner-title');
            const $subTitleEl = $('.banner-container .banner-p1 .banner-sub-title');
            const $bp2El = $('.banner-container .banner-p2-box');
            const $bp2ImgEl = $('.banner-container .banner-p2-img');
            const winW = $(window).width();
            const attr = { transition: 'opacity 1s ease' };

            if (r > 0.8) {
                $el.css({ opacity: r, 'transition-delay': 0, ...attr });
                $titleEl.css({ opacity: r, 'transition-delay': 0, ...attr });
                $bp2El.css({ transform: `translateY(25vh)`, opacity: 0, transition: 'transform 1s ease, opacity 1s ease' });
                $bp2ImgEl.css({ opacity: 0, ...attr });
            }

            if (r >= 0.9) {
                $el.css({ opacity: 1, 'transition-delay': 0, ...attr });
                $titleEl.css({ opacity: 1, 'transition-delay': 0, ...attr });
                $subTitleEl.css({ opacity: 1, transition: 'opacity 1s ease 0.7s' });
            }

            if (r < 0.9) {
                $subTitleEl.css({ opacity: 0, transition: 'opacity 0.2s ease 0s' });
            }

            if (r <= 0.8) {
                $el.css({ opacity: 0, 'transition-delay': 0, ...attr });
                $titleEl.css({ opacity: 0, 'transition-delay': 0, ...attr });
            }

            if (r < 0.7) {
                $el.css({ opacity: 0, 'transition-delay': 0, 'z-index': 7, ...attr });
                $titleEl.css({ opacity: 0, 'transition-delay': 0, 'z-index': 8, ...attr });
                $bp2ImgEl.css({ opacity: 0, ...attr });
                $bp2El.css({ transform: 'translateY(0px)', opacity: 1, transition: 'transform 1s ease, opacity 1s ease' });
            }

            if (r < 0.5) {
                $bp2ImgEl.css({ opacity: 1, transition: 'opacity 1.7s ease' });
            }

            if (r < 0.4) {
                $bp2El.css({
                    transform: `translateY(${winW <= 540 ? 19 : 25}vh)`,
                    opacity: 1,
                    transition: 'transform 1s ease, opacity 1s ease'
                });
            }

            if (r >= 0.3) {
                $el.css({ 'z-index': 0, height: 'calc(100vh - var(--header-height) - var(--subnav-height))' });
            }

            if (r < 0.3) {
                $el.css({ 'z-index': 0 });
                $titleEl.css({ 'z-index': 0 });
            }
        }
    };

    // 初始化 IntersectionObserver
    const initIntersectionObserver = () => {
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach(item => {
                    const func = item.target.getAttribute('animate');
                    if (typeof myAnimate[func] === 'function') {
                        myAnimate[func](item.intersectionRatio.toFixed(1), item.target, item.boundingClientRect.y);
                    }
                });
            },
            {
                root: null,
                threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
            }
        );
        document.querySelectorAll('[animate]').forEach(element => io.observe(element));
    };

    const initSlick = () => {
        // 轮播配置
        const slickConfig = {
            infinite: false,
            slidesToShow: 1,
            variableWidth: true,
            arrows: false, // 禁用默认箭头
            dots: false // 禁用默认圆点
        };

        // 轮播初始化函数
        const initCarousel = (carouselNumber) => {
            const $carousel = $(`.carousel-list-img-${carouselNumber} .carousel-list-img-item-list`);
            const prevSelector = `.carousel-${carouselNumber}-prev`;
            const nextSelector = `.carousel-${carouselNumber}-next`;

            // 检查轮播容器是否存在
            if ($carousel.length === 0) {
                console.warn(`未找到第${carouselNumber}个轮播元素`);
                return;
            }

            // 初始化slick轮播
            $carousel.slick(slickConfig);

            // 绑定控制按钮事件
            $(prevSelector).on('click', function () {
                $carousel.slick('slickPrev');
            });

            $(nextSelector).on('click', function () {
                $carousel.slick('slickNext');
            });

            // 监听轮播状态变化
            $carousel.on('afterChange', function (event, slick, currentSlide) {
                const $prevBtn = $(prevSelector);
                const $nextBtn = $(nextSelector);
                let hasHttp = false
                const imgs = $(event.currentTarget).find(`.carousel-list-img-item:nth-child(${currentSlide + 1}) img`)
                imgs.each(function () {
                    const img = $(this)
                    if (img && img.attr('src').includes('http') && img.css('display') == 'block') {
                        hasHttp = true
                    }
                })
                if (!hasHttp) {
                    imgs.lazyload({ effect: "fadeIn" })
                }
                let hasHttp2 = false
                const nexImgs = $(event.currentTarget).find(`.carousel-list-img-item:nth-child(${currentSlide + 2}) img`)
                nexImgs.each(function () {
                    const img = $(this)
                    if (img && img.attr('src').includes('http') && img.css('display') == 'block') {
                        hasHttp2 = true
                    }
                })
                if (!hasHttp2) {
                    nexImgs.lazyload({ effect: "fadeIn" })
                }
                // 更新按钮状态
                $prevBtn.prop('disabled', currentSlide === 0);
                $nextBtn.prop('disabled', currentSlide >= slick.slideCount - slick.options.slidesToShow);
            });

            // 初始化按钮状态（第一页时禁用上一页按钮）
            $(prevSelector).prop('disabled', true);
        };

        // 初始化所有轮播
        for (let i = 1; i <= 3; i++) {
            initCarousel(i);
        }
    };

    // 悬浮导航栏控制
    const initFloatingNav = () => {
        const floatingNav = document.getElementById('megaFloatingNav');
        if (!floatingNav) return;

        let lastScrollTop = 0;
        const firstScreenHeight = window.innerHeight; // 第一屏高度

        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            
            // 当滚动超过第一屏（即到达第二屏）时显示悬浮栏
            if (scrollTop > firstScreenHeight) {
                floatingNav.classList.add('show');
            } else {
                floatingNav.classList.remove('show');
            }
            
            lastScrollTop = scrollTop;
        };

        // 使用节流优化滚动性能
        let ticking = false;
        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    handleScroll();
                    ticking = false;
                });
                ticking = true;
            }
        });

        // 初始检查
        handleScroll();
    };

    // 初始化所有功能
    try {
        initIntersectionObserver();
        initSlick();
        initFloatingNav();
    } catch (e) {
        console.error('初始化动画失败:', e);
    }
});